export const DOCUMENTATION = 'documentation'
export const APPROVAL = 'approval'
export const LEASE = 'lease'

export const ALL_PROCESSES = [DOCUMENTATION, APPROVAL, LEASE] as const

export type Process = (typeof ALL_PROCESSES)[number]
